<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <page>
    <template v-slot:content>
      <transition name="slidedown">
        <div v-if="crumbsVisible" class="page-crumbs">
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <router-link
                :key="`crumb_${crumb.name}`"
                v-for="crumb in $route.meta.crumbs"
                :to="{ name: crumb.name }"
                tag="li"
              >
                <a
                  ><span class="link">{{ crumb.label }}</span></a
                >
              </router-link>
              <li class="is-active">
                <a href="#" aria-current="page">{{ $t("All galleries") }}</a>
              </li>
            </ul>
          </nav>
        </div>
      </transition>
      <div class="page">
        <section class="page-section">
          <br />
          <div class="page-section-content">
            <div class="title is-bold is-size-4">{{ $t("Most popular") }}</div>
            <div class="columns">
              <div class="column">
                <page-tile
                  :title="$t('Blooming')"
                  :subtitle="$t('All plants that are currently in bloom')"
                  :to="{
                    name: ROUTE_NAMES.GALLERY,
                    params: { id: 'bc3ebc3c-253e-43a9-9243-a763708d013g' }
                  }"
                >
                  <template v-slot:image>
                    <img
                      src="https://static.bz-uk.roamingowl.com/images/640/7183.jpg"
                      class="is-hoverable-image cover"
                      :alt="$t('Blooming right now image')"
                    />
                  </template>
                </page-tile>
              </div>
              <div class="column"></div>
              <div class="column"></div>
            </div>
            <hr class="divider" />
            <div class="title is-bold is-size-4">
              {{ $t("Skleníkové expozice") }}
            </div>
            <div class="columns">
              <div class="column">
                <page-tile
                  :title="$t('Subtropické rostliny')"
                  :to="{
                    name: ROUTE_NAMES.GALLERY,
                    params: { id: '5129baed-c264-48c5-b01d-36c1581a4a9c' }
                  }"
                >
                  <template v-slot:image>
                    <img
                      src="https://static.bz-uk.roamingowl.com/images/640/7282.webp"
                      class="is-hoverable-image cover"
                      :alt="$t('Subtropické rostliny')"
                    />
                  </template>
                </page-tile>
              </div>
              <div class="column">
                <page-tile
                  :title="$t('Sukulentní rostliny')"
                  :to="{
                    name: ROUTE_NAMES.GALLERY,
                    params: { id: '3c4674f8-f50f-437d-9931-41aee804d01c' }
                  }"
                >
                  <template v-slot:image>
                    <img
                      src="https://static.bz-uk.roamingowl.com/images/640/8446.webp"
                      class="is-hoverable-image cover"
                      :alt="$t('Sukulentní rostliny')"
                    />
                  </template>
                </page-tile>
              </div>
              <div class="column">
                <page-tile
                  :title="$t('Tropické rostliny')"
                  :to="{
                    name: ROUTE_NAMES.GALLERY,
                    params: { id: '1d905164-0fa4-4ab0-b6df-3642ddc6c022' }
                  }"
                >
                  <template v-slot:image>
                    <img
                      src="https://static.bz-uk.roamingowl.com/images/640/8878.webp"
                      class="is-hoverable-image cover"
                      :alt="$t('Tropické rostliny')"
                    />
                  </template>
                </page-tile>
              </div>
            </div>
            <hr class="divider" />
            <div class="title is-bold is-size-4">{{ $t("Other") }}</div>
            <div class="columns">
              <div class="column">
                <page-tile
                  :title="$t('Fauna botanické zahrady')"
                  :to="{
                    name: ROUTE_NAMES.GALLERY,
                    params: { id: '3beab0d6-0635-47f7-9e0a-2318b30dd969' }
                  }"
                >
                  <template v-slot:image>
                    <img
                      src="https://static.bz-uk.roamingowl.com/images/640/7205.webp"
                      class="is-hoverable-image cover"
                      :alt="$t('Fauna botanické zahrady')"
                    />
                  </template>
                </page-tile>
              </div>
              <div class="column">
                <page-tile
                  :title="$t('Venkovní expozice')"
                  :to="{
                    name: ROUTE_NAMES.GALLERY,
                    params: { id: 'be135e2a-e451-411e-8754-3163716d204f' }
                  }"
                >
                  <template v-slot:image>
                    <img
                      src="https://static.bz-uk.roamingowl.com/images/640/7325.webp"
                      class="is-hoverable-image cover"
                      :alt="$t('Venkovní expozice')"
                    />
                  </template>
                </page-tile>
              </div>
              <div class="column"></div>
            </div>
          </div>
        </section>
      </div>
    </template>
  </page>
</template>
<script>
//https://register.bz-uk.roamingowl.com/widgets/dp-gallery/bc3ebc3c-253e-43a9-9243-a763708d013g
import Page from "./../common/page";
import PageTile from "./../common/page-tile";
import { format } from "timeago.js";
import { ROUTE_NAMES } from "@/routes";

export default {
  data() {
    return {
      crumbsVisible: false
    };
  },
  methods: {
    timeAgo(date) {
      return format(date);
    }
  },
  components: {
    Page,
    PageTile
  },
  computed: {
    ROUTE_NAMES() {
      return ROUTE_NAMES;
    }
  },
  metaInfo: {
    title: "Is blooming"
  },
  async mounted() {
    this.crumbsVisible = true;
  }
};
</script>
<style lang="scss" scoped>
@import "./../../styles/index";
@import "./page-scoped";

.divider {
  background-color: #e0e0e0;
  height: 1px;
}

.cover {
  object-fit: cover;
}

.link {
  color: $color-text;
  cursor: pointer;

  &:hover {
    @include link-underline(#e1e1e1, $color-text, $color-selection);
  }
}
</style>
